/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum EFormePersonneSsLf {
    Contact = 'Contact',
    ChefEntreprise = 'ChefEntreprise',
    Tuteur = 'Tuteur'
}


export function EFormePersonneSsLfFromJSON(json: any): EFormePersonneSsLf {
    return EFormePersonneSsLfFromJSONTyped(json, false);
}

export function EFormePersonneSsLfFromJSONTyped(json: any, ignoreDiscriminator: boolean): EFormePersonneSsLf {
    return json as EFormePersonneSsLf;
}

export function EFormePersonneSsLfToJSON(value?: EFormePersonneSsLf | null): any {
    return value as any;
}

